module.exports = __webpack_public_path__ + "static/media/baliza.30aaff58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/thumbs/baliza.jpg
// module id = 239
// module chunks = 0